import Axios from "axios";
import {
    SET_INV_PO_RECEIVE_LIST,
    UNSET_INV_PO_RECEIVE_LIST,
} from "@/store/mutation-types.js";
import {
    getInvPoReceiveList,
    saveUpdateInvPoReceive,
    getInvPoReceiveById as getInvPoReceiveByIdApi
} from "@/store/api";

const state = {
    getInvPoReceiveList: [],
    editingPoReceive: null,
}

const getters = {
    getInvPoReceiveList(state) {
        return state.getInvPoReceiveList;
    },
    getEditinPoReceive(state) {
        return state.editingPoReceive;
    }
}

const mutations = {
    [SET_INV_PO_RECEIVE_LIST](state, data) {
        state.getInvPoReceiveList = data;
    },
    [UNSET_INV_PO_RECEIVE_LIST](state) {
        state.getInvPoReceiveList = [];
    },
    setEditingPoReceive(state, poReceive) {
        state.editingPoReceive = poReceive;
    }
}

const actions = {

    saveUpdateInvPoReceive({ commit }, data) {
        commit("SET_LOADING", { color: "primary" })
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateInvPoReceive, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then(() => {
                    commit("UNSET_LOADING");
                })
        })
    },

    getInvPoReceiveList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(getInvPoReceiveList, data)
                .then(function (response) {
                    commit('SET_INV_PO_RECEIVE_LIST', response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_INV_PO_RECEIVE_LIST');
                    reject(error);
                })
                .then(() => {
                    
                })
        })
    },

    getInvPoReceiveById({ commit }, id) {
        const getInvPoReceiveById = `${getInvPoReceiveByIdApi}/${id}`;
        return new Promise((resolve, reject) => {
            Axios.post(getInvPoReceiveById)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    reject(error);
                });
            });
    }

}

export default {
    state,
    getters,
    mutations,
    actions,
}